<template>
  <BasicLayout>
    <template #wrapper>
      <el-tabs active-name="1" tab-position="left" style="background-color: #ffffff;min-height: 800px">
        <el-tab-pane name="1" label="用户分组">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <span>用户分组</span>
              <el-button v-permisaction="['config:userGroup:add']" type="primary" size="mini" style="margin-left: 16px;" @click="edit(0)">新增</el-button>
              <clear-cache-apply />
              <sync-data />
            </div>
            <el-table size="small" :data="tableData" border style="width: 100%">
              <el-table-column prop="groupId" label="分组ID" width="100px" align="center" />
              <el-table-column prop="name" label="分组名称" width="150px" align="center" />
              <el-table-column label="标签" align="center">
                <template slot-scope="scope">
                  <span>{{ handleShowLabelName(scope.row.label) }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="remark" label="备注" align="center" />
              <el-table-column fixed="right" label="操作" width="100">
                <template slot-scope="scope">
                  <el-button v-permisaction="['config:userGroup:edit']" type="text" size="small" @click="edit(scope.row.id)">编辑</el-button>
                </template>
              </el-table-column>
            </el-table>
<!--            <pagination v-show="total>0" background :page.sync="queryParams.pageIndex" :limit.sync="queryParams.pageSize" :total="total" @pagination="getTables" />-->
          </el-card>
        </el-tab-pane>
        <el-tab-pane name="2" label="用户标签">
          <el-card class="box-card">
            <div slot="header" class="clearfix">
              <CommonExcel ref="CommonExcelRef" :import-p="'config:userLabel:import'" :export-p="'config:userLabel:export'" :import-method="importCfg" :export-method="exportCfg" :get-table="labelData"/>
              <el-popover style="margin-left: 1rem" placement="bottom" title="标签类型" width="800" trigger="click" :content="showType()">
                <el-button slot="reference" size="mini" type="primary">标签类型</el-button>
              </el-popover>
            </div>
            <template>
              <el-table size="mini" :data="list" border style="width: 100%">
                <el-table-column v-for="(item,index) in title" :key="index" align="center" :fixed="index < 2" :label="item" :width="handleWidth(index)">
                  <template slot-scope="{row,$index}">{{ row[index] }}</template>
                </el-table-column>
              </el-table>
            </template>
          </el-card>
        </el-tab-pane>
      </el-tabs>

    </template>
  </BasicLayout>
</template>

<script>
import CommonExcel from '@/components/CommonExcel/index.vue'
import {
  getUserLabelList,
  importUserLabelCfg
} from '@/api/config/user-label-cfg'
import { Message } from 'element-ui'
import { downloadExcelMultiSheet } from '@/utils/excel'
import { getUserTypeList } from '@/api/config/user-group-cfg'
import { getCacheQuery, setCacheQuery } from '@/utils'
import SyncData from '@/components/syncData/index.vue'
import ClearCacheApply from "@/components/clear_cache_apply";

export default {
  name: 'UserGroup',
  components: {
    ClearCacheApply,
    SyncData,
    CommonExcel
  },
  data() {
    return {
      total: 0,
      list: [],
      data: [],
      tableData: [],
      titleTran: [],
      loading: false,
      queryParams: {
        pageIndex: 1,
        pageSize: 10
      },
      title: [],
      operator: [
        { key: 1, value: '大于等于' },
        { key: 2, value: '大于' },
        { key: 3, value: '等于' },
        { key: 4, value: '小于等于' },
        { key: 5, value: '小于' },
        { key: 6, value: '包含' }
      ],
      type: [
        { key: 1, value: '关卡' },
        { key: 2, value: '体力' },
        { key: 3, value: '金币' },
        { key: 4, value: '版本' },
        { key: 5, value: '付费总额' },
        { key: 6, value: '国家地区' },
        { key: 7, value: '设备类型' },
        { key: 8, value: '广告渠道' },
        { key: 9, value: 'UID尾号' },
        { key: 10, value: '注册时间' },
        { key: 11, value: '生命周期' },
        { key: 12, value: '流失天数' },
        { key: 13, value: '近3个活跃日在线时长' },
        { key: 14, value: '所有付费日的日均付费金额' },
        { key: 15, value: '沉默付费天数' },
        { key: 16, value: '近7天支付总金额' },
        { key: 17, value: '日均广告次数' },
        { key: 18, value: 'RFM-R' },
        { key: 19, value: 'RFM-F' },
        { key: 20, value: 'RFM-M' },
        { key: 21, value: 'FB 用户' },
        { key: 22, value: 'VIP' },
        { key: 23, value: '语言' },
      ]
    }
  },
  created() {
    this.getTables()
    this.labelData()
  },
  methods: {
    handleClose(d) {
      this.drawer = false
    },
    edit(id) {
      this.$router.push({ name: 'UserGroupEdit', query: { id: id }})
    },
    handleShowLabelName(label) {
      const str = []
      for (let i = 0; i < label.length; i++) {
        const labelId = label[i]
        for (let j = 0; j < this.list.length; j++) {
          if (labelId == this.list[j][0]) {
            str.push(this.list[j][1])
          }
        }
      }
      return str.join('，')
    },
    getTables(event) {
      this.loading = true
      this.queryParams = getCacheQuery(this.$options.name, this.queryParams, event)
      getUserTypeList(this.queryParams).then(res => {
        setCacheQuery(this.$options.name, this.queryParams)
        this.tableData = res.data.list
        this.total = res.data.count
        this.loading = false
      })
    },
    labelData() {
      this.$nextTick(() => {
        this.loading = true
        getUserLabelList(this.queryParams).then(res => {
          this.loading = false
          this.data = res.data.list
          this.handleMakeTableData()
        })
      })
    },
    handleCheckData() {
      for (let i = 0; i < this.data.length; i++) {
        for (let j = this.data[i].conditions.length - 1; j >= 0; j--) {
          const row = this.data[i].conditions[j]
          if (row.type === 0 || row.operator === 0) {
            this.data[i].conditions.splice(j, 1)
          }
        }
      }
    },
    handleMakeTableData() {
      this.handleCheckData()
      const title = ['标签ID', '标签名', '状态']
      const titleTran = ['id', 'name', 'status']
      const data = []
      let conditionLen = 0
      for (let i = 0; i < this.data.length; i++) {
        if (this.data[i].conditions.length > conditionLen) {
          conditionLen = this.data[i].conditions.length
        }
      }
      for (let i = 1; i <= conditionLen; i++) {
        title.push('玩家属性#' + i + '类型', '玩家属性#' + i + '运算符', '玩家属性#' + i + '数值')
        titleTran.push('conditions#' + i + '.type', 'conditions#' + i + '.operator', 'conditions#' + i + '.value')
      }
      for (let i = 0; i < this.data.length; i++) {
        const row = JSON.parse(JSON.stringify(this.data[i]))
        const tmp = [row.id, row.name, row.status === 0 ? '关闭' : '开启']
        row.conditions = this.$refs.CommonExcelRef.tranToTarget(row.conditions, { operator: this.operator, type: this.type })
        for (let i = 0; i < conditionLen; i++) {
          if (row.conditions[i] !== undefined) {
            tmp.push(row.conditions[i].type)
            tmp.push(row.conditions[i].operator)
            tmp.push(row.conditions[i].value)
          } else {
            tmp.push('', '', '')
          }
        }
        data.push(tmp)
      }
      this.title = title
      this.titleTran = titleTran
      this.list = data
    },
    handleWidth(index) {
      index = index + 1
      if (index === 1 || index === 3) {
        return 80
      }
      if (index === 2) {
        return 180
      }
      if ((index - 3) % 3 === 2) {
        return 130
      }
      if ((index - 3) % 3 === 0) {
        return 130
      }
      return 180
    },
    exportCfg() {
      const time = new Date().getTime()
      const list = [this.titleTran]
      for (let i = 0; i < this.list.length; i++) {
        list.push(this.list[i])
      }
      downloadExcelMultiSheet('标签配置-' + time, ['标签配置'], [this.title], [list])
      return Promise.reject()
    },
    importCfg(excelData) {
      const ret = excelData.data[0].sheetData
      for (let i = 0; i < ret.length; i++) {
        ret[i].status = ret[i].status === '开启' ? 1 : 0
        const conditions = this.$refs.CommonExcelRef.tranToTarget(ret[i].conditions, { operator: this.operator, type: this.type }, false, 'value', 'key')
        let type = -1
        for (let j = 0; j < conditions.length; j++) {
          if (conditions[j].type != '' && type !== -1 && type != conditions[j].type) {
            Message({ message: ret[i].labelId + ',暂不支持单标签混合类型', type: 'error', duration: 5 * 1000 })
            this.uploadLoading = false
            e.target.value = null
            return
          } else {
            type = conditions[j].type
          }
        }
        ret[i].conditions = conditions
      }
      importUserLabelCfg({ path: excelData.path, data: JSON.stringify(ret) }).then(res => {
        this.msgSuccess(res.msg)
        this.tableData()
      })
    },
    showType() {
      const type = []
      for (let i = 0; i < this.type.length; i++) {
        type.push(this.type[i].value)
      }
      return type.join(' ， ')
    }
  }
}
</script>

<style scoped>
</style>
